import React, { useState } from "react";
import { TalkToExpertModal } from "./modal/TalkToExpertModal";
import { motion, AnimatePresence } from "framer-motion"; // Import motion and AnimatePresence
import cross from "../../assets/svg/roundcross.svg";
import grade1_5Web from "../../assets/Banners/inmobius_banner_grade_1_5.png";
import grade1_5MWeb from "../../assets/Banners/inmobius_mweb_banner_grade_1_5.png";
import grade6_10Web from "../../assets/Banners/inmobius_banner_grade_6_10.jpg";
import grade6_10MWeb from "../../assets/Banners/inmobius_mweb_banner_grade_6_10.jpg";
import grade11Web from "../../assets/Banners/inmobius_banner_grade_11.jpg";
import grade11MWeb from "../../assets/Banners/inmobius_mweb_banner_grade_11.jpg";
import grade12_13Web from "../../assets/Banners/inmobius_banner_grade_12_13.jpg";
import grade12_13MWeb from "../../assets/Banners/inmobius_mweb_banner_grade_12_13.jpg";
import { useSelector, useDispatch } from "react-redux";
import { getIsAlertOpen } from "../../store/app/selectors";
import { setIsAlertOpen } from "../../store/app/app.slice";
import { getUserInfo } from "../../store/auth/selectors";
import useLeadCapture from "../UseLeadCapture";

const AlertBar = ({ currentPath }) => {
  const isAlertOpen = useSelector(getIsAlertOpen);
  const user = useSelector(getUserInfo);
  const grade = parseInt(user?.grade_id, 10); // Ensure proper base is specified.
  const dispatch = useDispatch();
  const { handelAlerbarLead } = useLeadCapture();
  const [showModal, setShowModal] = useState(false);
  const handleCloseAlert = () => {
    dispatch(setIsAlertOpen(false));
  };

  const getAlertBanner = () => {
    if (typeof window === "undefined") return null; // Avoid errors in SSR.
    const deviceType = window.innerWidth <= 768 ? "mobile" : "web";

    const banners = {
      "1-5": {
        web: {
          banner: grade1_5Web,
          url: "https://bit.ly/4ihr7Th"
        },
        mobile: {
          banner: grade1_5MWeb,
          url: "https://bit.ly/4ihr7Th"
        }
      },
      "6-10": {
        web: {
          banner: grade6_10Web,
          url: "https://bit.ly/3YhDN4n"
        },
        mobile: {
          banner: grade6_10MWeb,
          url: "https://bit.ly/3YhDN4n"
        }
      },
      11: {
        web: {
          banner: grade11Web,
          url: "https://bit.ly/3ZN93Ix"
        },
        mobile: {
          banner: grade11MWeb,
          url: "https://bit.ly/3ZN93Ix"
        }
      },
      "12-13": {
        web: {
          banner: grade12_13Web,
          url: "https://bit.ly/3ZN93Ix"
        },
        mobile: {
          banner: grade12_13MWeb,
          url: "https://bit.ly/3ZN93Ix"
        }
      }
    };

    if (grade >= 1 && grade <= 5) {
      return banners["1-5"][deviceType];
    } else if (grade >= 6 && grade <= 10) {
      return banners["6-10"][deviceType];
    } else if (grade == 11) {
      return banners["11"][deviceType];
    } else if (grade >= 12 && grade <= 13) {
      return banners["12-13"][deviceType];
    }

    return null; // Fallback if no conditions match.
  };

  const handleDisplay = () => {
    if ((currentPath.includes("/exam-page") || currentPath.includes("reports")) && isAlertOpen) {
      return "block";
    }
    return "none";
  };

  const alertBanner = getAlertBanner();
  const handelLsqCall = () => {
    const params = {
      img_link: `https://inmobiusinfinitylearn.com/static/media/${alertBanner.banner}`,
      redirect_link: alertBanner.url,
      source: "top_banner"
    };
    handelAlerbarLead(params);
  };
  return (
    <>
      <AnimatePresence>
        {isAlertOpen && (
          <motion.div
            key="alert-bar"
            style={{ display: handleDisplay() }}
            className="alertBar-cont"
            initial={{ y: 0 }} // Start at the top
            animate={{ y: 0 }} // Keep it at the top when open
            exit={{ y: "-100%" }} // Slide up when closed
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            <div
              onClick={(e) => {
                if (grade >= 11) {
                  e.preventDefault();
                  setShowModal(true);
                }
                handelLsqCall();
              }}
              style={{ position: "relative" }}
            >
              <img src={cross} onClick={handleCloseAlert} className="alertClose" alt="Close" />
              {alertBanner ? (
                grade < 11 ? (
                  <a href={alertBanner.url} target="_blank" rel="noopener noreferrer">
                    <img src={alertBanner.banner} className="alertbarImage" alt="Alertbar" />
                  </a>
                ) : (
                  <img src={alertBanner.banner} className="alertbarImage" alt="Alertbar" />
                )
              ) : (
                <p>No banner available</p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <TalkToExpertModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default AlertBar;
